<template>
  <button
    class="frisbuy-good-button"
    :class="{ 'frisbuy-good-button-with-popup': isGoodsPopupOpen }"
    @click="$emit('clickButton')"
  >
    <div class="frisbuy-good-button-container">
      <span>
        {{ text }}

        <svg
          v-if="!isLink"
          width="9"
          height="6"
          viewBox="0 0 9 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          :style="{
            transform: `rotate(${isGoodsPopupOpen ? '180deg' : '0'})`,
          }"
        >
          <path
            d="M7.5 4.5L4.5 1.5L1.5 4.5"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <a
        v-if="isLink"
        target="_blank"
        :href="linkUrl"
        @click="$emit('clickLink')"
      ></a>
    </div>
  </button>
</template>

<style scoped lang="scss">
@keyframes changeBackgroundColor {
  0% {
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0);
  }

  80% {
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0);
  }

  100% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  }
}

.frisbuy-good-button {
  position: absolute;
  bottom: 4.5vh;
  right: 50%;
  transform: translateX(50%);

  width: 157px;
  height: 3.75vh;

  font-family: "Helvetica";
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;

  border: 0 solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;

  cursor: pointer;

  padding: 0;

  z-index: 11;

  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);

  animation-name: changeBackgroundColor;
  animation-duration: 2s;
  animation-iteration-count: 1;

  @media screen and (max-width: 768px) {
    bottom: 2vh;
  }

  &-container {
    display: flex;

    align-items: center;

    width: fit-content;
    height: 100%;

    color: #000;
    // color: #fff;
    text-align: center;

    margin: 0 auto;
    padding: 10px 0;
  }

  a {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  span {
    display: inline-block;
  }

  &-with-popup {
    background: #ffffff;
    border: 0 solid #d2d2d2;
    z-index: 13;

    span {
      color: #000;
    }
  }
}
</style>

<script>
export default {
  emits: ["clickButton", "clickLink"],

  props: {
    isGoodsPopupOpen: {
      type: Boolean,
      require: false,
      default: false,
    },

    text: {
      type: String,
      require: true,
    },

    isLink: {
      type: Boolean,
      require: false,
      default: false,
    },

    linkUrl: {
      type: String,
      require: false,
      default: "#",
    },
  },

  data() {
    return {};
  },
};
</script>
